import { LocalRootState } from '@app-redux/store';

export const isShowDemoMessage = (state: LocalRootState) => {
  return state.local.app.showDemoMessage;
};
